import { ReactNode, MouseEvent } from 'react';
import clsx from 'clsx';

import { handleSpaceClick } from 'shared/lib/utils';

import styles from './styles.module.scss';

export type OvalButtonProps = {
  children: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  onContextMenu?: (
    e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
  ) => void;
  href?: string;
  classNames?: string;
  target?: string;
  rel?: string;
  ariaLabel?: string;
  testId?: string;
};

export const OvalButton = ({
  children,
  onClick,
  onContextMenu,
  href,
  classNames,
  target,
  rel,
  ariaLabel,
  testId,
}: OvalButtonProps) => {
  const componentClassNames = clsx(
    'btn btn-oval rhythm-button',
    styles.ovalButton,
    classNames,
  );

  if (href) {
    return (
      <a
        href={href}
        target={target}
        rel={rel}
        onClick={onClick}
        onKeyDown={handleSpaceClick}
        onContextMenu={onContextMenu}
        className={componentClassNames}
        aria-label={ariaLabel}
        data-testid={testId}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      onClick={onClick}
      onKeyDown={handleSpaceClick}
      onContextMenu={onContextMenu}
      className={componentClassNames}
      aria-label={ariaLabel}
      data-testid={testId}
    >
      {children}
    </button>
  );
};
